import { render, staticRenderFns } from "./klistboxgroup.vue?vue&type=template&id=1f0c68be"
import script from "./klistboxgroup.vue?vue&type=script&lang=js"
export * from "./klistboxgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports